var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.2 65.8",
    style: {
      enableBackground: "new 0 0 65.2 65.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -21.4,
    y: -21.1,
    width: 108,
    height: 108
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "path"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.1,61.5h-40.7V4.3h40.7v14.2l4.3-4.3v-12c0-1.2-1-2.2-2.2-2.2c0,0,0,0,0,0h-45.1 C139,0,138,1,138,2.2c0,0,0,0,0,0v61.5c0,1.2,1,2.2,2.2,2.2h45.1c1.2,0,2.2-1,2.2-2.2V39.8l-4.3,4.3V61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    style: {
      fill: "#FFFFFF"
    },
    d: "M176.7,9.6h-27.9c-0.9,0-1.7,0.7-1.7,1.7s0.7,1.7,1.7,1.7l0,0h27.9c0.9,0,1.7-0.7,1.7-1.7 C178.3,10.3,177.6,9.6,176.7,9.6C176.7,9.6,176.7,9.6,176.7,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.3,20.1c0-0.9-0.7-1.7-1.7-1.7h-27.9c-0.9,0-1.7,0.7-1.7,1.6c0,0.9,0.7,1.7,1.6,1.7 c0,0,0.1,0,0.1,0h27.9C177.6,21.7,178.3,21,178.3,20.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    style: {
      fill: "#FFFFFF"
    },
    d: "M174.3,27.2h-25.6c-0.9,0-1.7,0.7-1.7,1.6c0,0.9,0.7,1.7,1.6,1.7c0,0,0.1,0,0.1,0H171 L174.3,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.1,38.2c0.2-0.8,0.5-1.5,0.9-2.2h-17.2c-0.9,0-1.7,0.7-1.7,1.6c0,0.9,0.7,1.7,1.6,1.7 c0,0,0.1,0,0.1,0h16L165.1,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    style: {
      fill: "#FFFFFF"
    },
    d: "M148.7,44.9c-0.9,0-1.7,0.7-1.7,1.6c0,0.9,0.7,1.7,1.6,1.7c0,0,0.1,0,0.1,0h14.6 c-0.4-1-0.5-2.2-0.2-3.3H148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    style: {
      fill: "#FFFFFF"
    },
    d: "M201.8,12.6c-1.8-1.8-4.7-1.8-6.6,0l-24.5,24.5c-0.7,0.7-1.2,1.5-1.4,2.4l-2,6.6 c-0.1,0.4,0.1,0.9,0.5,1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0l6.6-2c0.9-0.3,1.7-0.8,2.4-1.4l24.5-24.5 C203.6,17.3,203.6,14.4,201.8,12.6L201.8,12.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment-icon.1d4ee316f7aaff7095b25dfbdadc501b.svg";
export { ForwardRef as ReactComponent };